export const USER_DATA = {
    helderpedro: {
      fullName: 'Helder Pedro',
      medicalQuestion: 'Qual é a principal função da vitamina D no organismo?',
      answer: ['Absorção de cálcio', 'Saúde óssea'],
      table: 'Tabela 1',
      hints: ['É sintetizada pela pele através da luz solar.', 'É crucial para ossos fortes.', 'Relacionada com o metabolismo do cálcio.']
    },
    joaocarvalho: {
      fullName: 'Joao Carvalho',
      isRotating: 'true',
      medicalQuestion: 'Qual é a principal função da vitamina D no organismo?',
      answer: ['Absorção de cálcio', 'Saúde óssea'],
      table: 'Tabela 1',
      hints: ['É sintetizada pela pele através da luz solar.', 'É crucial para ossos fortes.', 'Relacionada com o metabolismo do cálcio.']
    },
    anapedro: {
      fullName: 'Ana Pedro',
      medicalQuestion: 'Qual é a principal função do sistema linfático?',
      answer: ['Defesa do organismo', 'Transporte de linfa'],
      table: 'Tanzania',
      hints: ['Está relacionado com a imunidade.', 'Transporta linfa e células do sistema imunitário.', 'Ajuda na drenagem de líquidos.']
    },
    filipapedro: {
      fullName: 'Filipa Pedro',
      medicalQuestion: 'Qual é a principal função das plaquetas sanguíneas?',
      answer: ['Coagulação sanguínea'],
      table: 'Tabela 3',
      hints: ['São células sanguíneas.', 'Essenciais para a cicatrização de feridas.', 'Previnem hemorragias.']
    },
    mariamarques: {
      fullName: 'Maria Marques',
      medicalQuestion: 'O que causa a miastenia grave?',
      answer: ['Anticorpos contra receptores de acetilcolina'],
      table: 'Tabela 4',
      hints: ['Afeta a comunicação entre nervos e músculos.', 'É uma doença autoimune.', 'Causa fraqueza muscular.']
    },
    antoniopedro: {
      fullName: 'Antonio Pedro',
      medicalQuestion: 'Qual é a função do fígado na metabolização de medicamentos?',
      answer: ['Desintoxicação', 'Metabolismo de fármacos'],
      table: 'Tabela 5',
      hints: ['É o principal órgão envolvido na desintoxicação do corpo.', 'Transforma substâncias em compostos menos tóxicos.', 'Responsável por metabolizar muitos medicamentos.']
    },
    luciliapedro: {
      fullName: 'Lucilia Pedro',
      medicalQuestion: 'Qual é a diferença entre a respiração pulmonar e a respiração celular?',
      answer: ['Respiração pulmonar é troca de gases', 'Respiração celular é produção de ATP'],
      table: 'Tabela 6',
      hints: ['A respiração pulmonar ocorre nos pulmões.', 'A respiração celular ocorre nas mitocôndrias.', 'A respiração celular gera energia.']
    },
    dorapedro: {
      fullName: 'Dora Pedro',
      medicalQuestion: 'O que é a síndrome de Cushing?',
      answer: ['Excesso de cortisol', 'Hipercortisolismo'],
      table: 'Tabela 7',
      hints: ['Pode ser causado por tumores na glândula suprarrenal.', 'Os sintomas incluem ganho de peso e fraqueza muscular.', 'Está relacionada com a produção excessiva de cortisol.']
    },
    ruibarquina: {
      fullName: 'Rui Barquina',
      medicalQuestion: 'Qual é o principal fator de risco para o desenvolvimento de arteriosclerose?',
      answer: ['Hipertensão', 'Tabagismo', 'Hiperlipidemia'],
      table: 'Tabela 8',
      hints: ['A hipertensão danifica as artérias.', 'O tabagismo acelera o processo de endurecimento das artérias.', 'Elevados níveis de colesterol também são um fator de risco.']
    },
    hugopedro: {
      fullName: 'Hugo Pedro',
      medicalQuestion: 'Qual é a função da insulina no metabolismo?',
      answer: ['Reduz os níveis de glicose no sangue', 'Facilita a entrada de glicose nas células'],
      table: 'Tabela 9',
      hints: ['É produzida pelo pâncreas.', 'Está relacionada com a regulação da glicose.', 'O seu défice está associado ao diabetes tipo 1.']
    },
    susetealmeida: {
      fullName: 'Susete Almeida',
      medicalQuestion: 'Qual é a principal causa do infarto do miocárdio?',
      answer: ['Obstrução das artérias coronárias', 'Aterosclerose'],
      table: 'Portugal',
      hints: ['A obstrução pode ser causada por placas de gordura.', 'O infarto ocorre quando o fluxo sanguíneo para o coração é bloqueado.', 'Está frequentemente associado a fatores como tabagismo e hipertensão.']
    },
    davidpedro: {
      fullName: 'David Pedro',
      medicalQuestion: 'O que caracteriza a doença de Alzheimer?',
      answer: ['Acúmulo de placas de proteína beta-amiloide', 'Perda de memória', 'Declínio cognitivo'],
      table: 'Tabela 11',
      hints: ['É uma doença neurodegenerativa.', 'Afeta principalmente idosos.', 'Está associada a falhas na comunicação entre células nervosas.']
    },
    carlosromana: {
      fullName: 'Carlos Romana',
      medicalQuestion: 'Qual é o papel dos glóbulos vermelhos no transporte de oxigénio?',
      answer: ['Transportam oxigénio dos pulmões para os tecidos'],
      table: 'Tabela 12',
      hints: ['Contêm hemoglobina, que se liga ao oxigénio.', 'São células sem núcleo.', 'Facilitam a troca gasosa.']
    },
    elisabete: {
      fullName: 'Elisabete',
      medicalQuestion: 'Qual é a principal função do sistema endócrino?',
      answer: ['Regulação hormonal'],
      table: 'Portugal',
      hints: ['Composto por glândulas que produzem hormonas.', 'Controla funções como o crescimento e o metabolismo.', 'Está envolvido em processos como o stress e a reprodução.']
    },
    eduardoromana: {
      fullName: 'Eduardo Romana',
      medicalQuestion: 'Quais são os fatores de risco para o desenvolvimento de diabetes tipo 2?',
      answer: ['Obesidade', 'Sedentarismo', 'Histórico familiar'],
      table: 'Tabela 14',
      hints: ['A obesidade aumenta a resistência à insulina.', 'A falta de exercício contribui para o aumento de glicose no sangue.', 'O histórico familiar pode aumentar a predisposição para a doença.']
    },
    miguelromana: {
      fullName: 'Miguel Romana',
      medicalQuestion: 'Qual é a principal função dos rins?',
      answer: ['Filtração de resíduos', 'Regulação do equilíbrio hídrico e eletrolítico'],
      table: 'Tabela 15',
      hints: ['Produzem urina para eliminar resíduos.', 'Regulam a quantidade de água no corpo.', 'São fundamentais para a homeostase.']
    },
    carolaguiar: {
      fullName: 'Carol Aguiar',
      medicalQuestion: 'Qual é o principal componente do sangue responsável pelo transporte de oxigénio?',
      answer: ['Hemoglobina', 'Glóbulos vermelhos'],
      table: 'Croácia',
      hints: ['Está presente nos glóbulos vermelhos.', 'Liga-se ao oxigénio nos pulmões.', 'É responsável pela cor vermelha do sangue.']
    },
    maridoleiticialeao: {
      fullName: 'Marido Leticia Leão',
      medicalQuestion: 'Qual é o papel do sistema linfático no organismo?',
      answer: ['Drenagem de líquidos', 'Defesa imunológica'],
      table: 'Croácia',
      hints: ['Ajuda na remoção de toxinas.', 'Transporta linfa rica em glóbulos brancos.', 'É parte do sistema imunológico.']
    },
    veronicachomiski: {
      fullName: 'Veronica Chomiski',
      medicalQuestion: 'O que causa a hipertensão arterial?',
      answer: ['Estresse', 'Consumo excessivo de sal', 'Sedentarismo'],
      table: 'Croácia',
      hints: ['Está relacionada ao estilo de vida.', 'Pode ser influenciada pela dieta.', 'É conhecida como “assassino silencioso”.']
    },
    fabiochomiski: {
      fullName: 'Fabio Chomiski',
      medicalQuestion: 'Qual é a função principal dos glóbulos brancos?',
      answer: ['Defesa contra infeções', 'Imunidade'],
      table: 'Croácia',
      hints: ['Estão envolvidos na resposta imunológica.', 'Combatem agentes patogénicos.', 'Estão presentes no sistema linfático.']
    },
    namgustavo: {
      fullName: 'Namorado do Gustavo',
      medicalQuestion: 'Qual é o principal órgão responsável pela filtração do sangue?',
      answer: ['Rins'],
      table: 'Croácia',
      hints: ['Produzem urina como subproduto.', 'Regulam o equilíbrio hídrico.', 'São vitais para a homeostase.']
    },
    gustavo: {
      fullName: 'Gustavo',
      medicalQuestion: 'Qual é a principal função do pâncreas no sistema digestivo?',
      answer: ['Produção de insulina', 'Secreção de enzimas digestivas'],
      table: 'Croácia',
      hints: ['Ajuda na regulação da glicose no sangue.', 'Secreta suco pancreático.', 'É essencial para a digestão de gorduras e carboidratos.']
    },
    leticialeao: {
      fullName: 'Leticia Leão',
      medicalQuestion: 'O que é anemia?',
      answer: ['Deficiência de glóbulos vermelhos', 'Falta de hemoglobina'],
      table: 'Croácia',
      hints: ['Pode causar cansaço extremo.', 'Está relacionada ao transporte de oxigénio.', 'Pode ser causada por deficiência de ferro.']
    },
    rapha: {
      fullName: 'Rapha',
      medicalQuestion: 'O que é o sistema nervoso central composto?',
      answer: ['Cérebro', 'Medula espinhal'],
      table: 'Croácia',
      hints: ['É o principal centro de controle do corpo.', 'Transmite sinais elétricos.', 'Está protegido por ossos e meninges.']
    },
    carolleslen: {
      fullName: 'Carol Leslen',
      medicalQuestion: 'O que é febre?',
      answer: ['Aumento da temperatura corporal', 'Resposta imunológica'],
      table: 'Eslovenia',
      hints: ['É uma resposta do sistema imunológico.', 'Pode indicar infeções.', 'A temperatura excede 37,5°C.']
    },
    catia: {
      fullName: 'Catia',
      medicalQuestion: 'Qual é o papel do fígado no metabolismo?',
      answer: ['Produção de bile', 'Filtra toxinas', 'Armazena glicogénio'],
      table: 'Eslovenia',
      hints: ['É essencial na digestão de gorduras.', 'Tem uma função de desintoxicação.', 'Converte glicose em energia armazenada.']
    },
    maridocatia: {
      fullName: 'Marido da Catia',
      medicalQuestion: 'Qual é a causa mais comum de dor de cabeça?',
      answer: ['Desidratação', 'Estresse', 'Tensão muscular'],
      table: 'Eslovenia',
      hints: ['Pode ser aliviada bebendo água.', 'Muitas vezes associada a preocupações.', 'Pode ocorrer após esforço prolongado.']
    },
    filhocarolleslen: {
      fullName: 'Filho de Carol Leslen',
      medicalQuestion: 'Qual é o principal risco de uma queimadura grave?',
      answer: ['Perda de fluidos', 'Infeções'],
      table: 'Eslovenia',
      hints: ['Pode levar à desidratação severa.', 'É crucial proteger a área lesionada.', 'Pode precisar de atenção médica urgente.']
    },
    mulhergabriel: {
      fullName: 'Mulher do Gabriel',
      medicalQuestion: 'O que é hipoglicemia?',
      answer: ['Baixo nível de glicose no sangue'],
      table: 'Eslovenia',
      hints: ['É comum em pessoas com diabetes.', 'Pode causar tontura e fraqueza.', 'Requer ingestão rápida de açúcar.']
    },
    gabriel: {
      fullName: 'Gabriel',
      medicalQuestion: 'O que é a apneia do sono?',
      answer: ['Interrupção temporária da respiração durante o sono'],
      table: 'Eslovenia',
      hints: ['Pode causar cansaço durante o dia.', 'Está associada ao ronco.', 'Pode aumentar o risco de doenças cardíacas.']
    },
    maridocarolleslen: {
      fullName: 'Marido da Carol Leslen',
      medicalQuestion: 'Quais são os sintomas de desidratação?',
      answer: ['Boca seca', 'Tontura', 'Fadiga'],
      table: 'Eslovenia',
      hints: ['Pode ocorrer devido a calor excessivo.', 'Urina torna-se mais concentrada.', 'Pode causar sede intensa.']
    },
    fabioazevedo: {
      fullName: 'Fábio Azevedo',
      medicalQuestion: 'Qual é a principal função do sistema cardiovascular?',
      answer: ['Transporte de oxigênio', 'Circulação sanguínea'],
      table: 'Montenegro',
      hints: ['É composto pelo coração e vasos sanguíneos.', 'Transporte de oxigênio e nutrientes para os tecidos.', 'Essencial para a manutenção da vida.']
    },
    namfabio: {
      fullName: 'Nam. Fábio',
      medicalQuestion: 'Qual é a principal função do sistema respiratório?',
      answer: ['Troca de gases', 'Fornecimento de oxigênio'],
      table: 'Montenegro',
      hints: ['O oxigênio é absorvido nos pulmões.', 'O dióxido de carbono é expelido durante a expiração.', 'Permite a respiração celular.']
    },
    namoradarentodias: {
      fullName: 'Namorada Renato Dias',
      medicalQuestion: 'O que caracteriza a anemia ferropriva?',
      answer: ['Deficiência de ferro', 'Falta de hemoglobina'],
      table: 'Montenegro',
      hints: ['É uma das causas mais comuns de anemia.', 'Causa cansaço e fraqueza.', 'O ferro é essencial para a produção de hemoglobina.']
    },
    renatodias: {
      fullName: 'Renato Dias',
      medicalQuestion: 'Qual é a função principal da vitamina A?',
      answer: ['Saúde ocular', 'Fortalecimento do sistema imunológico'],
      table: 'Montenegro',
      hints: ['Essencial para a visão noturna.', 'Ajuda na função do sistema imunológico.', 'Pode ser encontrada em alimentos como cenoura e fígado.']
    },
    mulherpedrofigueiredo: {
      fullName: 'Mulher Pedro Figueiredo',
      medicalQuestion: 'Qual é a principal causa da hipertensão arterial?',
      answer: ['Excesso de sódio', 'Estresse', 'Sedentarismo'],
      table: 'Montenegro',
      hints: ['Está frequentemente relacionada ao consumo excessivo de sal.', 'Pode ser controlada com dieta e exercícios.', 'Está associada ao aumento da pressão sanguínea.']
    },
    joaobalao: {
      fullName: 'João Balão',
      medicalQuestion: 'O que é a febre tifóide?',
      answer: ['Infecção bacteriana', 'Causada pela bactéria Salmonella typhi'],
      table: 'Montenegro',
      hints: ['É uma doença infecciosa.', 'Afeta o trato gastrointestinal.', 'Os sintomas incluem febre alta e dor abdominal.']
    },
    namoradajoaobalao: {
      fullName: 'Namorada João Balão',
      medicalQuestion: 'Qual é o principal efeito da desidratação no organismo?',
      answer: ['Diminuição da pressão sanguínea', 'Cansaço', 'Confusão mental'],
      table: 'Montenegro',
      hints: ['Pode levar a sintomas como tontura e fraqueza.', 'Afeta o volume sanguíneo.', 'A ingestão de líquidos é essencial para o equilíbrio do corpo.']
    },
    pedrofigueiredo: {
      fullName: 'Pedro Figueiredo',
      medicalQuestion: 'Qual é o efeito da insulina no corpo?',
      answer: ['Reduz os níveis de glicose no sangue', 'Facilita o armazenamento de glicose nas células'],
      table: 'Montenegro',
      hints: ['É produzida pelo pâncreas.', 'Essencial para o controle do açúcar no sangue.', 'Está associada ao tratamento de diabetes.']
    },
    thaismontagnini: {
      fullName: 'Thais Montagnini',
      medicalQuestion: 'Qual é a principal função do sistema nervoso?',
      answer: ['Controle e coordenação das funções corporais', 'Processamento de informações'],
      table: 'Marrocos',
      hints: ['Composto pelo cérebro, medula espinhal e nervos.', 'Permite a comunicação entre as células do corpo.', 'Fundamental para as respostas rápidas a estímulos.']
    },
    marido_thaismontagnini: {
      fullName: 'Marido Thais Montagnini',
      medicalQuestion: 'O que é a hipertensão arterial?',
      answer: ['Pressão arterial elevada', 'Problema no sistema cardiovascular'],
      table: 'Marrocos',
      hints: ['Pode causar danos aos vasos sanguíneos.', 'É uma condição silenciosa, muitas vezes sem sintomas.', 'Está associada a fatores como dieta e estresse.']
    },
    tayna: {
      fullName: 'Tayna',
      medicalQuestion: 'O que causa a pneumonia?',
      answer: ['Infecção pulmonar', 'Bactérias, vírus ou fungos'],
      table: 'Marrocos',
      hints: ['Afeta principalmente os pulmões.', 'Causa tosse, febre e dificuldade para respirar.', 'Pode ser tratada com antibióticos dependendo da causa.']
    },
    anacarolina: {
      fullName: 'Ana Carolina',
      medicalQuestion: 'Qual é a principal função dos rins?',
      answer: ['Filtrar o sangue', 'Produção de urina'],
      table: 'Marrocos',
      hints: ['São responsáveis pela excreção de resíduos metabólicos.', 'Mantêm o equilíbrio de líquidos e eletrólitos.', 'Essenciais para a filtragem de toxinas.']
    },
    marido_anacarolina: {
      fullName: 'Marido Ana Carolina',
      medicalQuestion: 'O que é a diabetes tipo 2?',
      answer: ['Resistência à insulina', 'Hiperglicemia'],
      table: 'Marrocos',
      hints: ['É uma doença metabólica crônica.', 'Está associada a níveis elevados de glicose no sangue.', 'Pode ser controlada com dieta, exercício e medicamentos.']
    },
    edwardcastrillon: {
      fullName: 'Edward Castrillon',
      medicalQuestion: 'Qual é a função do sistema linfático?',
      answer: ['Defesa do organismo', 'Transporte de linfa'],
      table: 'Marrocos',
      hints: ['Transporta células do sistema imunológico.', 'Ajuda na remoção de resíduos celulares.', 'É fundamental para a imunidade e drenagem de líquidos.']
    },
    marido_edwardcastrillon: {
      fullName: 'Marido Edward Castrillon',
      medicalQuestion: 'O que caracteriza a esclerose múltipla?',
      answer: ['Doença autoimune', 'Dano na mielina dos nervos'],
      table: 'Marrocos',
      hints: ['Afeta o sistema nervoso central.', 'Pode causar problemas de movimento e sensação.', 'É mais comum em jovens adultos.']
    },
    tarcila: {
      fullName: 'Tarcila',
      medicalQuestion: 'O que é a síndrome de Down?',
      answer: ['Trissomia do cromossomo 21', 'Alteração genética'],
      table: 'Marrocos',
      hints: ['É uma condição genética.', 'Causa atraso no desenvolvimento intelectual e físico.', 'É uma das causas mais comuns de deficiência intelectual.']
    },
    eliasbanagouro: {
      fullName: 'Elias Banagouro',
      medicalQuestion: 'Qual é a função principal da vitamina C?',
      answer: ['Fortalecer o sistema imunológico', 'Auxiliar na cicatrização'],
      table: 'Marrocos',
      hints: ['É um antioxidante poderoso.', 'Promove a absorção de ferro.', 'Presente em frutas cítricas como laranja e limão.']
    },
    filhotarcila: {
      fullName: 'Filho Tarcila',
      medicalQuestion: 'Qual é a função principal do sistema esquelético?',
      answer: ['Sustentação do corpo', 'Proteção dos órgãos internos'],
      table: 'Marrocos',
      hints: ['Composto por ossos e articulações.', 'Fundamental para o movimento e postura do corpo.', 'Ajuda a proteger órgãos vitais como o cérebro e o coração.']
    },
    marido_rute: {
      fullName: 'Marido Rute',
      medicalQuestion: 'O que é a hipertensão arterial?',
      answer: ['Pressão arterial elevada', 'Problema no sistema cardiovascular'],
      table: 'Qatar',
      hints: ['Pode causar danos aos vasos sanguíneos.', 'É uma condição silenciosa, muitas vezes sem sintomas.', 'Está associada a fatores como dieta e estresse.']
    },
    zeza: {
      fullName: 'Zeza',
      medicalQuestion: 'Qual é a principal função do sistema nervoso?',
      answer: ['Controle e coordenação das funções corporais', 'Processamento de informações'],
      table: 'Qatar',
      hints: ['Composto pelo cérebro, medula espinhal e nervos.', 'Permite a comunicação entre as células do corpo.', 'Fundamental para as respostas rápidas a estímulos.']
    },
    andrebarrancos: {
      fullName: 'Andre Barrancos',
      medicalQuestion: 'O que é a diabetes tipo 2?',
      answer: ['Resistência à insulina', 'Hiperglicemia'],
      table: 'Qatar',
      hints: ['É uma doença metabólica crônica.', 'Está associada a níveis elevados de glicose no sangue.', 'Pode ser controlada com dieta, exercício e medicamentos.']
    },
    eduardoramana: {
      fullName: 'Eduardo Romana',
      medicalQuestion: 'O que caracteriza a doença de Alzheimer?',
      answer: ['Acúmulo de placas de proteína beta-amiloide', 'Perda de memória', 'Declínio cognitivo'],
      table: 'Qatar',
      hints: ['É uma doença neurodegenerativa.', 'Afeta principalmente idosos.', 'Está associada a falhas na comunicação entre células nervosas.']
    },
    isabelromana: {
      fullName: 'Isabel Romana',
      medicalQuestion: 'Qual é a função das plaquetas sanguíneas?',
      answer: ['Coagulação sanguínea'],
      table: 'Qatar',
      hints: ['São células sanguíneas.', 'Essenciais para a cicatrização de feridas.', 'Previnem hemorragias.']
    },
    rute: {
      fullName: 'Rute',
      medicalQuestion: 'Qual é a principal causa do infarto do miocárdio?',
      answer: ['Obstrução das artérias coronárias', 'Aterosclerose'],
      table: 'Qatar',
      hints: ['A obstrução pode ser causada por placas de gordura.', 'O infarto ocorre quando o fluxo sanguíneo para o coração é bloqueado.', 'Está frequentemente associado a fatores como tabagismo e hipertensão.']
    },
    biancarodriguez: {
      fullName: 'Bianca Rodriguez',
      medicalQuestion: 'Qual é a função principal dos rins?',
      answer: ['Filtrar o sangue', 'Produção de urina'],
      table: 'Qatar',
      hints: ['São responsáveis pela excreção de resíduos metabólicos.', 'Mantêm o equilíbrio de líquidos e eletrólitos.', 'Essenciais para a filtragem de toxinas.']
    },
    pauloalmeida: {
      fullName: 'Paulo Almeida',
      medicalQuestion: 'Qual é a função da vitamina C no organismo?',
      answer: ['Fortalecer o sistema imunológico', 'Antioxidante'],
      table: 'Dinamarca',
      hints: ['É essencial para a formação do colágeno.', 'Ajuda na absorção de ferro.', 'Tem propriedades antioxidantes.']
    },
    teresaalmeida: {
      fullName: 'Teresa Almeida',
      medicalQuestion: 'O que caracteriza a diabetes tipo 1?',
      answer: ['Deficiência na produção de insulina', 'Dependência de insulina'],
      table: 'Dinamarca',
      hints: ['É uma doença autoimune.', 'Afeta principalmente crianças e jovens.', 'O pâncreas não produz insulina.']
    },
    monicaalmeida: {
      fullName: 'Monica Almeida',
      medicalQuestion: 'O que causa a hipertensão arterial?',
      answer: ['Pressão arterial elevada de forma crônica', 'Problema cardiovascular'],
      table: 'Dinamarca',
      hints: ['Fatores como dieta, estresse e genética podem influenciar.', 'A hipertensão pode danificar os vasos sanguíneos.', 'Muitas vezes é assintomática.']
    },
    margaridaalmeida: {
      fullName: 'Margarida Almeida',
      medicalQuestion: 'Qual é a função principal do sistema respiratório?',
      answer: ['Troca de oxigênio e dióxido de carbono', 'Respiração'],
      table: 'Dinamarca',
      hints: ['Acontece principalmente nos pulmões.', 'Está relacionado com a captação de oxigênio para o corpo.', 'Permite a eliminação do dióxido de carbono.']
    },
    henriquebarbosa: {
      fullName: 'Henrique Barbosa',
      medicalQuestion: 'Qual é a principal função do sistema linfático?',
      answer: ['Defesa do organismo', 'Transporte de linfa'],
      table: 'Dinamarca',
      hints: ['Está relacionado com a imunidade.', 'Transporta linfa e células do sistema imunitário.', 'Ajuda na drenagem de líquidos.']
    },
    fernanda: {
      fullName: 'Fernanda',
      medicalQuestion: 'O que causa a miastenia grave?',
      answer: ['Anticorpos contra receptores de acetilcolina'],
      table: 'Dinamarca',
      hints: ['Afeta a comunicação entre nervos e músculos.', 'É uma doença autoimune.', 'Causa fraqueza muscular.']
    },
    igor: {
      fullName: 'Igor',
      medicalQuestion: 'Qual é a principal função do fígado na metabolização de medicamentos?',
      answer: ['Desintoxicação', 'Metabolismo de fármacos'],
      table: 'Dinamarca',
      hints: ['É o principal órgão envolvido na desintoxicação do corpo.', 'Transforma substâncias em compostos menos tóxicos.', 'Responsável por metabolizar muitos medicamentos.']
    },
    irmasuzyalmeida: {
      fullName: 'Irmã Suzy Almeida',
      medicalQuestion: 'Qual é a função das plaquetas sanguíneas?',
      answer: ['Coagulação sanguínea'],
      table: 'Dinamarca',
      hints: ['São células sanguíneas.', 'Essenciais para a cicatrização de feridas.', 'Previnem hemorragias.']
    },
    namoradacorreia: {
      fullName: 'Namorada Correia',
      medicalQuestion: 'Qual é a principal causa do infarto do miocárdio?',
      answer: ['Obstrução das artérias coronárias', 'Aterosclerose'],
      table: 'Andorra',
      hints: ['A obstrução pode ser causada por placas de gordura.', 'O infarto ocorre quando o fluxo sanguíneo para o coração é bloqueado.', 'Está frequentemente associado a fatores como tabagismo e hipertensão.']
    },
    diogomatos: {
      fullName: 'Diogo Matos',
      medicalQuestion: 'O que caracteriza a doença de Alzheimer?',
      answer: ['Acúmulo de placas de proteína beta-amiloide', 'Perda de memória', 'Declínio cognitivo'],
      table: 'Andorra',
      hints: ['É uma doença neurodegenerativa.', 'Afeta principalmente idosos.', 'Está associada a falhas na comunicação entre células nervosas.']
    },
    anacatarinanunes: {
      fullName: 'Ana Catarina Nunes',
      medicalQuestion: 'Qual é a função do sistema respiratório?',
      answer: ['Troca de oxigênio e dióxido de carbono', 'Respiração'],
      table: 'Andorra',
      hints: ['Acontece principalmente nos pulmões.', 'Está relacionado com a captação de oxigênio para o corpo.', 'Permite a eliminação do dióxido de carbono.']
    },
    tania: {
      fullName: 'Tania',
      medicalQuestion: 'O que causa a miastenia grave?',
      answer: ['Anticorpos contra receptores de acetilcolina'],
      table: 'Andorra',
      hints: ['Afeta a comunicação entre nervos e músculos.', 'É uma doença autoimune.', 'Causa fraqueza muscular.']
    },
    andrecardoso: {
      fullName: 'André Cardoso',
      medicalQuestion: 'Qual é a principal função do fígado na metabolização de medicamentos?',
      answer: ['Desintoxicação', 'Metabolismo de fármacos'],
      table: 'Andorra',
      hints: ['É o principal órgão envolvido na desintoxicação do corpo.', 'Transforma substâncias em compostos menos tóxicos.', 'Responsável por metabolizar muitos medicamentos.']
    },
    filhoandrecardoso2: {
      fullName: 'Filho Andre Cardoso 2',
      medicalQuestion: 'Qual é a principal função do sistema linfático?',
      answer: ['Defesa do organismo', 'Transporte de linfa'],
      table: 'Andorra',
      hints: ['Está relacionado com a imunidade.', 'Transporta linfa e células do sistema imunitário.', 'Ajuda na drenagem de líquidos.']
    },
    filhaandrecardoso1: {
      fullName: 'Filha Andre Cardoso 1',
      medicalQuestion: 'O que caracteriza a diabetes tipo 1?',
      answer: ['Deficiência na produção de insulina', 'Dependência de insulina'],
      table: 'Andorra',
      hints: ['É uma doença autoimune.', 'Afeta principalmente crianças e jovens.', 'O pâncreas não produz insulina.']
    },
    biacarvalho: {
      fullName: 'Bia Carvalho',
      medicalQuestion: 'Qual é a função das plaquetas sanguíneas?',
      answer: ['Coagulação sanguínea'],
      table: 'Andorra',
      hints: ['São células sanguíneas.', 'Essenciais para a cicatrização de feridas.', 'Previnem hemorragias.']
    },
    diogocorreira: {
      fullName: 'Diogo Correira',
      medicalQuestion: 'O que é a síndrome de Cushing?',
      answer: ['Excesso de cortisol', 'Hipercortisolismo'],
      table: 'Andorra',
      hints: ['Pode ser causado por tumores na glândula suprarrenal.', 'Os sintomas incluem ganho de peso e fraqueza muscular.', 'Está relacionada com a produção excessiva de cortisol.']
    },
    amandamirai: {
      fullName: 'Amanda Mirai',
      medicalQuestion: 'Qual é o principal sintoma da síndrome do pânico?',
      answer: ['Ansiedade intensa', 'Fobia', 'Palpitações'],
      table: 'Itália',
      hints: ['Ocorre de forma súbita e intensa.', 'É frequentemente acompanhado de medo irracional.', 'Pode afetar a respiração e aumentar a frequência cardíaca.']
    },
    joaoleme: {
      fullName: 'João Leme',
      medicalQuestion: 'O que caracteriza a síndrome de Down?',
      answer: ['Trissomia do cromossomo 21', 'Desenvolvimento cognitivo abaixo da média'],
      table: 'Itália',
      hints: ['É uma condição genética.', 'Está associada a atraso no desenvolvimento e características físicas distintas.', 'Afeta a capacidade cognitiva e de aprendizado.']
    },
    maridotarcila: {
      fullName: 'Marido Tarcila',
      medicalQuestion: 'Qual é a principal causa da hipertensão arterial?',
      answer: ['Fatores genéticos e ambientais', 'Obesidade', 'Sedentarismo'],
      table: 'Itália',
      hints: ['É uma das principais causas de doenças cardíacas.', 'A hipertensão pode ser causada por dieta rica em sal.', 'Pode ser controlada com medicamentos e mudanças no estilo de vida.']
    },
    maridojoaleme: {
      fullName: 'Marido João Leme',
      medicalQuestion: 'O que caracteriza a doença pulmonar obstrutiva crônica (DPOC)?',
      answer: ['Obstrução das vias respiratórias', 'Dificuldade em respirar', 'Tosse crônica'],
      table: 'Itália',
      hints: ['Principalmente causada por tabagismo.', 'Afeta a troca de oxigênio nos pulmões.', 'É uma doença progressiva e irreversível.']
    },
    elauna: {
      fullName: 'Elauna',
      medicalQuestion: 'O que é a fibromialgia?',
      answer: ['Dor muscular generalizada', 'Fadiga', 'Distúrbios do sono'],
      table: 'Itália',
      hints: ['A dor é sentida em várias partes do corpo.', 'É uma doença crônica.', 'A causa exata ainda não é completamente compreendida.']
    },
    douglas: {
      fullName: 'Douglas',
      medicalQuestion: 'O que é o transtorno obsessivo-compulsivo (TOC)?',
      answer: ['Pensamentos obsessivos e comportamentos compulsivos', 'Ansiedade', 'Ritualização'],
      table: 'Itália',
      hints: ['A pessoa sente a necessidade de realizar ações repetitivas.', 'Os pensamentos obsessivos podem causar grande sofrimento.', 'É tratado com terapia comportamental e medicamentos.']
    },
    joanamirai: {
      fullName: 'Joana Mirai',
      medicalQuestion: 'O que caracteriza a síndrome de Turner?',
      answer: ['Monossomia do cromossomo X', 'Atraso no desenvolvimento sexual', 'Baixa estatura'],
      table: 'Itália',
      hints: ['Afeta apenas mulheres.', 'Está associada a problemas no sistema cardiovascular.', 'Pode levar a problemas renais e infertilidade.']
    },
    geraldina: {
      fullName: 'Geraldina',
      medicalQuestion: 'O que é a insuficiência renal?',
      answer: ['Impossibilidade dos rins de filtrar adequadamente os resíduos', 'Acúmulo de toxinas no sangue'],
      table: 'Itália',
      hints: ['Pode ser aguda ou crônica.', 'Afeta o equilíbrio de fluidos e eletrólitos no corpo.', 'Pode ser causada por diabetes e hipertensão.']
    },
    lunamirai: {
      fullName: 'Luana Mirai',
      medicalQuestion: 'O que é a endometriose?',
      answer: ['Crescimento anormal de tecido endometrial fora do útero', 'Dor pélvica crônica', 'Infertilidade'],
      table: 'Itália',
      hints: ['Afeta principalmente mulheres em idade fértil.', 'Os sintomas incluem dor intensa durante a menstruação.', 'Pode afetar órgãos como os ovários e as trompas de falópio.']
    },
    adrianacosta: {
      fullName: 'Adriana Costa',
      medicalQuestion: 'Quais são os principais sintomas da diabetes tipo 2?',
      answer: ['Sede excessiva', 'Fome constante', 'Visão turva'],
      table: 'Tanzania',
      hints: ['Está frequentemente associada ao excesso de peso e à falta de atividade física.', 'Os sintomas podem ser sutis no início.', 'Pode levar a complicações graves se não tratada.']
    },
    diogorocha: {
      fullName: 'Diogo Rocha',
      medicalQuestion: 'O que é a hipertensão arterial?',
      answer: ['Pressão arterial elevada', 'Risco para doenças cardíacas', 'Sintomas frequentemente ausentes'],
      table: 'Tanzania',
      hints: ['É conhecida como “assassina silenciosa”.', 'Pode ser causada por fatores como estresse e dieta rica em sal.', 'É controlável com medicação e mudanças no estilo de vida.']
    },
    filipacoelho: {
      fullName: 'Filipa Coelho',
      medicalQuestion: 'O que caracteriza a doença celíaca?',
      answer: ['Intolerância ao glúten', 'Danos ao intestino delgado', 'Problemas digestivos'],
      table: 'Tanzania',
      hints: ['É uma condição autoimune.', 'A única forma de tratamento é uma dieta sem glúten.', 'Pode causar deficiência de nutrientes e problemas de absorção.']
    },
    pedro: {
      fullName: 'Pedro',
      medicalQuestion: 'O que é o transtorno de déficit de atenção com hiperatividade (TDAH)?',
      answer: ['Falta de atenção', 'Impulsividade', 'Hiperatividade'],
      table: 'Tanzania',
      hints: ['Afeta principalmente crianças, mas pode persistir na vida adulta.', 'É tratado com medicamentos e terapia comportamental.', 'Pode afetar o desempenho acadêmico e social.']
    },
    nambarbara: {
      fullName: 'Nam. Barbara',
      medicalQuestion: 'O que é a esclerose múltipla?',
      answer: ['Doença autoimune que afeta o sistema nervoso central', 'Dificuldade em coordenar movimentos', 'Fadiga crônica'],
      table: 'Tanzania',
      hints: ['A causa exata não é completamente compreendida.', 'Pode causar lesões no cérebro e na medula espinhal.', 'Os sintomas variam amplamente de uma pessoa para outra.']
    },
    barbara: {
      fullName: 'Barbara',
      medicalQuestion: 'O que caracteriza a síndrome de Marfan?',
      answer: ['Distúrbio do tecido conjuntivo', 'Estatura alta e membros longos', 'Problemas cardíacos'],
      table: 'Tanzania',
      hints: ['A síndrome pode afetar o coração, os olhos e os ossos.', 'Está associada ao alongamento dos ossos e ligamentos.', 'Pode levar a complicações graves no coração.']
    },
    carinaportinha: {
      fullName: 'Carina Portinha',
      medicalQuestion: 'O que é a síndrome do ovário policístico?',
      answer: ['Desregulação hormonal', 'Cistos nos ovários', 'Irregularidades menstruais'],
      table: 'Tanzania',
      hints: ['Afeta a fertilidade e pode levar a problemas metabólicos.', 'Está frequentemente associada a excesso de pelos no corpo e acne.', 'Pode ser tratada com medicação e mudanças no estilo de vida.']
    },
    andre: {
      fullName: 'Andre Nam Barbara',
      medicalQuestion: 'O que é a doença de Parkinson?',
      answer: ['Doença neurodegenerativa', 'Tremores', 'Rigidez muscular'],
      table: 'Tanzania',
      hints: ['Afeta o movimento e pode levar a dificuldades motoras.', 'Está associada à falta de dopamina no cérebro.', 'É tratada com medicamentos e fisioterapia.']
    },
    filhacarina: {
      fullName: 'Filha Carina',
      medicalQuestion: 'O que caracteriza a anemia?',
      answer: ['Deficiência de glóbulos vermelhos ou hemoglobina', 'Fadiga', 'Palidez'],
      table: 'Tanzania',
      hints: ['Pode ser causada por deficiência de ferro, vitaminas ou outras condições.', 'É tratada com suplementos e mudanças na dieta.', 'Pode afetar o transporte de oxigênio pelo corpo.']
    },
    carme: {
      fullName: 'Carme',
      medicalQuestion: 'O que é a artrite reumatoide?',
      answer: ['Inflamação das articulações', 'Dor e rigidez', 'Desgaste articular'],
      table: 'South Africa',
      hints: ['É uma doença autoimune.', 'Pode afetar várias articulações de uma vez.', 'O tratamento pode envolver medicamentos anti-inflamatórios e imunossupressores.']
    },
    ritaramos: {
      fullName: 'Rita Ramos',
      medicalQuestion: 'O que é o diabetes tipo 1?',
      answer: ['Doença autoimune', 'Produção insuficiente de insulina', 'Necessidade de insulina externa'],
      table: 'South Africa',
      hints: ['Normalmente diagnosticada na infância ou adolescência.', 'Os sintomas incluem sede excessiva e urinação frequente.', 'O tratamento envolve a administração de insulina.']
    },
    mulherduartealemao: {
      fullName: 'Mulher Duarte Alemão',
      medicalQuestion: 'O que é a doença de Crohn?',
      answer: ['Doença inflamatória intestinal', 'Dor abdominal e diarreia', 'Perda de peso'],
      table: 'South Africa',
      hints: ['Pode afetar qualquer parte do trato digestivo.', 'Os sintomas incluem cólicas, fadiga e febre.', 'O tratamento envolve medicamentos anti-inflamatórios e imunossupressores.']
    },
    alvaroramos: {
      fullName: 'Alvaro Ramos',
      medicalQuestion: 'O que é a esclerose lateral amiotrófica (ELA)?',
      answer: ['Doença neurodegenerativa', 'Perda de controle muscular', 'Dificuldade para respirar'],
      table: 'South Africa',
      hints: ['Afeta as células nervosas que controlam os músculos.', 'A progressão é geralmente rápida e leva à paralisia.', 'Não há cura conhecida, mas tratamentos podem aliviar sintomas.']
    },
    tiagomarques: {
      fullName: 'Tiago Marques',
      medicalQuestion: 'O que é a síndrome do pânico?',
      answer: ['Ataques súbitos de medo intenso', 'Taquicardia e falta de ar', 'Sensação de perda de controle'],
      table: 'South Africa',
      hints: ['É um tipo de transtorno de ansiedade.', 'Pode ocorrer sem razão aparente ou como resposta ao estresse.', 'O tratamento pode envolver terapia cognitivo-comportamental e medicamentos ansiolíticos.']
    },
    xana: {
      fullName: 'Xana',
      medicalQuestion: 'O que é a depressão?',
      answer: ['Transtorno de humor', 'Sentimentos persistentes de tristeza', 'Perda de interesse nas atividades diárias'],
      table: 'South Africa',
      hints: ['Pode ser causada por fatores genéticos, ambientais ou psicológicos.', 'É tratada com terapia e/ou medicamentos antidepressivos.', 'Pode afetar significativamente a qualidade de vida.']
    },
    pedrolousa: {
      fullName: 'Pedro Lousa',
      medicalQuestion: 'O que é a hipertensão arterial?',
      answer: ['Pressão arterial elevada', 'Falta de sintomas iniciais', 'Risco para doenças cardíacas e derrames'],
      table: 'South Africa',
      hints: ['É chamada de “assassina silenciosa”.', 'Pode ser controlada com medicamentos e mudanças no estilo de vida.', 'O monitoramento regular da pressão arterial é importante.']
    },
    mariamarquez: {
      fullName: 'Maria Marques',
      medicalQuestion: 'O que é a doença celíaca?',
      answer: ['Intolerância ao glúten', 'Danos no intestino delgado', 'Diarreia e dor abdominal'],
      table: 'South Africa',
      hints: ['A única forma de tratamento é uma dieta sem glúten.', 'Pode levar a deficiências nutricionais se não tratada.', 'É uma condição autoimune que afeta a absorção de nutrientes.']
    },
    jennifer: {
      fullName: 'Jennifer',
      medicalQuestion: 'O que é a doença de Alzheimer?',
      answer: ['Perda de memória', 'Dificuldade em reconhecer rostos', 'Confusão'],
      table: 'Espanha',
      hints: ['Afeta a função cognitiva e a memória.', 'É uma forma comum de demência.', 'O tratamento pode envolver medicamentos para aliviar os sintomas.']
    },
    filhoandreia: {
      fullName: 'Filho Andreia',
      medicalQuestion: 'O que é a asma?',
      answer: ['Dificuldade para respirar', 'Chiado no peito', 'Tosse constante'],
      table: 'Espanha',
      hints: ['É uma doença crônica das vias respiratórias.', 'Os sintomas podem ser aliviados com medicamentos broncodilatadores e anti-inflamatórios.', 'Pode ser desencadeada por alérgenos ou exercícios.']
    },
    andreia: {
      fullName: 'Andreia',
      medicalQuestion: 'O que é a fibromialgia?',
      answer: ['Dor muscular generalizada', 'Fadiga constante', 'Distúrbios do sono'],
      table: 'Espanha',
      hints: ['É uma condição que causa dor em todo o corpo.', 'Os sintomas podem variar de pessoa para pessoa.', 'O tratamento pode incluir medicamentos e terapias de manejo da dor.']
    },
    maridoandreia: {
      fullName: 'Marido Andreia',
      medicalQuestion: 'O que é o câncer de pulmão?',
      answer: ['Crescimento anormal das células do pulmão', 'Tosse persistente', 'Dificuldade para respirar'],
      table: 'Espanha',
      hints: ['Fumantes têm maior risco, mas também pode afetar não fumantes.', 'Pode ser detectado por meio de radiografias ou tomografias.', 'O tratamento pode envolver cirurgia, quimioterapia e radioterapia.']
    },
    fabiana: {
      fullName: 'Fabiana',
      medicalQuestion: 'O que é a insuficiência renal?',
      answer: ['Função renal reduzida', 'Retenção de líquidos', 'Dificuldade para urinar'],
      table: 'Espanha',
      hints: ['Pode ser aguda ou crônica.', 'O tratamento pode envolver diálise ou transplante renal.', 'A insuficiência renal é uma condição séria que afeta a filtragem dos resíduos do corpo.']
    },
    claudia: {
      fullName: 'Claudia',
      medicalQuestion: 'O que é o hipertireoidismo?',
      answer: ['Produção excessiva de hormônios pela tireoide', 'Perda de peso', 'Aumento do ritmo cardíaco'],
      table: 'Espanha',
      hints: ['Pode causar sintomas como nervosismo e insônia.', 'O tratamento pode envolver medicamentos antitireoidianos, iodo radioativo ou cirurgia.', 'É mais comum em mulheres, especialmente na faixa etária de 20 a 40 anos.']
    },
    luizinho: {
      fullName: 'Luizinho',
      medicalQuestion: 'O que é o autismo?',
      answer: ['Transtorno do espectro autista', 'Dificuldade na comunicação social', 'Comportamentos repetitivos'],
      table: 'Espanha',
      hints: ['Afeta o desenvolvimento da comunicação e comportamento.', 'O tratamento envolve terapias comportamentais e educacionais.', 'Os sintomas variam de leve a grave, dependendo da pessoa.']
    },
    namlucinda: {
      fullName: 'Nam. Lucinda',
      medicalQuestion: 'O que é o câncer de mama?',
      answer: ['Crescimento anormal das células da mama', 'Presença de nódulos', 'Mudanças na forma ou tamanho da mama'],
      table: 'Espanha',
      hints: ['É um dos tipos mais comuns de câncer em mulheres.', 'A detecção precoce pode aumentar as chances de tratamento eficaz.', 'O tratamento pode envolver cirurgia, radioterapia, quimioterapia ou terapia hormonal.']
    },
    lucinda: {
      fullName: 'Lucinda',
      medicalQuestion: 'O que é a osteoporose?',
      answer: ['Perda de massa óssea', 'Aumento do risco de fraturas', 'Dores nas costas'],
      table: 'Espanha',
      hints: ['A osteoporose é mais comum em mulheres pós-menopausa.', 'Pode ser prevenida com dieta rica em cálcio e exercício físico.', 'O tratamento pode envolver medicamentos que fortalecem os ossos.']
    },
    cristianeduarte: {
      fullName: 'Cristiane Duarte',
      medicalQuestion: 'O que é a tuberculose?',
      answer: ['Infecção bacteriana', 'Tosse persistente', 'Suores noturnos'],
      table: 'Espanha',
      hints: ['Afeta geralmente os pulmões, mas pode atingir outros órgãos.', 'É tratada com antibióticos por um longo período.', 'É transmissível, mas pode ser prevenida com cuidados adequados.']
    },
    isabella: {
      fullName: 'Isabella',
      medicalQuestion: 'O que é a hepatite C?',
      answer: ['Infecção do fígado', 'Causa icterícia e dor abdominal', 'Pode levar à cirrose'],
      table: 'Espanha',
      hints: ['A infecção pode ser crônica e causar danos no fígado ao longo do tempo.', 'É transmitida principalmente por contato com sangue contaminado.', 'O tratamento envolve medicamentos antivirais que podem curar a infecção.']
    },
    carolinacosta: {
      fullName: 'Carolina Costa',
      medicalQuestion: 'O que é a doença celíaca?',
      answer: ['Intolerância ao glúten', 'Diarreia crônica', 'Dor abdominal'],
      table: 'Bolivia',
      hints: ['É uma condição autoimune que afeta o intestino delgado.', 'Pode ser diagnosticada por exames de sangue e biópsia intestinal.', 'O tratamento envolve uma dieta rigorosa sem glúten.']
    },
    maridoRita: {
      fullName: 'Marido Rita',
      medicalQuestion: 'O que é o AVC?',
      answer: ['Interrupção do fluxo sanguíneo no cérebro', 'Dificuldade para falar ou mover um lado do corpo', 'Perda de visão em um dos olhos'],
      table: 'Bolivia',
      hints: ['O AVC pode ser isquêmico ou hemorrágico.', 'Os sintomas podem variar dependendo da área do cérebro afetada.', 'O tratamento rápido pode reduzir os danos ao cérebro.']
    },
    andrePesquisa: {
      fullName: 'André Pesquisa',
      medicalQuestion: 'O que é a endometriose?',
      answer: ['Presença de tecido endometrial fora do útero', 'Dor intensa durante o ciclo menstrual', 'Infertilidade'],
      table: 'Bolivia',
      hints: ['Afeta principalmente mulheres em idade fértil.', 'Pode ser diagnosticada por meio de exames de imagem ou laparoscopia.', 'O tratamento pode envolver medicamentos ou cirurgia.']
    },
    namoradaCarolina: {
      fullName: 'Namorada Carolina',
      medicalQuestion: 'O que é o diabetes tipo 2?',
      answer: ['Resistência à insulina', 'Aumento da glicose no sangue', 'Fadiga constante'],
      table: 'Bolivia',
      hints: ['É mais comum em pessoas com sobrepeso ou sedentarismo.', 'O controle da glicose é feito com medicamentos, dieta e exercícios.', 'O diabetes tipo 2 pode levar a complicações sérias se não for controlado.']
    },
    lurdescosta: {
      fullName: 'Lurdes Costa',
      medicalQuestion: 'O que é a síndrome de Down?',
      answer: ['Transtorno genético', 'Atraso no desenvolvimento intelectual', 'Características físicas distintas'],
      table: 'Bolivia',
      hints: ['É causado por uma cópia extra do cromossomo 21.', 'O diagnóstico pode ser feito por exames genéticos.', 'O tratamento envolve apoio educacional e terapias para desenvolver habilidades.']
    },
    ritacosta: {
      fullName: 'Rita Costa',
      medicalQuestion: 'O que é a leucemia?',
      answer: ['Câncer do sangue', 'Fadiga extrema', 'Infecções frequentes'],
      table: 'Bolivia',
      hints: ['Afeta as células sanguíneas e pode ser aguda ou crônica.', 'O tratamento pode envolver quimioterapia, radioterapia ou transplante de medula óssea.', 'O diagnóstico é feito por exames de sangue e biópsias.']
    },
    bryancosta: {
      fullName: 'Brayan Costa',
      medicalQuestion: 'O que é a hipertensão?',
      answer: ['Pressão arterial elevada', 'Dores de cabeça frequentes', 'Fadiga'],
      table: 'Bolivia',
      hints: ['É uma condição crônica que pode levar a problemas cardíacos e renais.', 'Pode ser controlada com medicamentos, dieta e exercício físico.', 'A hipertensão é mais comum em pessoas com histórico familiar ou estilo de vida inadequado.']
    },
    anabeatriz: {
      fullName: 'Ana Beatriz',
      medicalQuestion: 'O que é a fibromialgia?',
      answer: ['Dor muscular generalizada', 'Fadiga intensa', 'Distúrbios do sono'],
      table: 'Peru',
      hints: ['É uma condição crônica que afeta os músculos e tecidos moles.', 'Os sintomas podem variar de pessoa para pessoa.', 'O tratamento envolve medicamentos, terapias físicas e controle do estresse.']
    },
    namAnaBeatriz: {
      fullName: 'Nam. Ana Beatriz',
      medicalQuestion: 'O que é a asma?',
      answer: ['Doença respiratória crônica', 'Dificuldade para respirar', 'Tosse persistente'],
      table: 'Peru',
      hints: ['Pode ser desencadeada por alergias, infecções respiratórias ou poluentes.', 'O tratamento envolve o uso de broncodilatadores e anti-inflamatórios.', 'Asma não tem cura, mas pode ser controlada com medicação.']
    },
    maribragatti: {
      fullName: 'Mari Bragatti',
      medicalQuestion: 'O que é o câncer de mama?',
      answer: ['Tumor maligno na mama', 'Nódulo indolor', 'Alterações na pele ou no formato da mama'],
      table: 'Peru',
      hints: ['O câncer de mama é mais comum em mulheres, mas pode afetar homens também.', 'O autoexame e a mamografia são importantes para o diagnóstico precoce.', 'O tratamento pode envolver cirurgia, quimioterapia ou radioterapia.']
    },
    gabi: {
      fullName: 'Gabi',
      medicalQuestion: 'O que é a esclerose múltipla?',
      answer: ['Doença autoimune que afeta o sistema nervoso central', 'Dificuldade de coordenação motora', 'Problemas de visão'],
      table: 'Peru',
      hints: ['É uma condição crônica que pode afetar a função motora e sensorial.', 'O tratamento visa reduzir os sintomas e melhorar a qualidade de vida.', 'Os sintomas variam de acordo com a gravidade da doença.']
    },
    rafaboggiani: {
      fullName: 'Rafa Boggiani',
      medicalQuestion: 'O que é o Alzheimer?',
      answer: ['Doença neurodegenerativa', 'Perda de memória progressiva', 'Confusão e mudanças de humor'],
      table: 'Peru',
      hints: ['Afeta principalmente idosos e tem evolução gradual.', 'Não tem cura, mas tratamentos podem ajudar a controlar os sintomas.', 'O diagnóstico é feito com base em exames cognitivos e exames de imagem.']
    },
    lavina: {
      fullName: 'Lavina',
      medicalQuestion: 'O que é a hipertireoidismo?',
      answer: ['Excesso de hormônios da tireoide', 'Aceleração do metabolismo', 'Perda de peso inexplicada'],
      table: 'Peru',
      hints: ['Pode causar sintomas como ansiedade, tremores e aumento da frequência cardíaca.', 'O tratamento pode envolver medicamentos antitireoidianos ou cirurgia.', 'O diagnóstico é feito por meio de exames de sangue.']
    },
    daria: {
      fullName: 'Daria',
      medicalQuestion: 'O que é a síndrome do pânico?',
      answer: ['Transtorno de ansiedade', 'Ataques de medo intenso', 'Dificuldade para respirar'],
      table: 'Peru',
      hints: ['Pode ocorrer sem aviso prévio e durar vários minutos.', 'O tratamento inclui terapia cognitivo-comportamental e medicamentos ansiolíticos.', 'A síndrome do pânico pode ser controlada com a ajuda de profissionais de saúde mental.']
    },
    maylacastro: {
      fullName: 'Mayla Castro',
      medicalQuestion: 'O que é a artrite reumatoide?',
      answer: ['Doença autoimune que afeta as articulações', 'Inflamação e dor nas articulações', 'Dificuldade para mover as articulações'],
      table: 'Peru',
      hints: ['É uma condição crônica que pode levar à deformação das articulações.', 'O tratamento envolve medicamentos anti-inflamatórios e imunossupressores.', 'O diagnóstico pode ser feito com exames de sangue e exames de imagem.']
    },
    mulherCarlosBV: {
      fullName: 'Mulher Carlos BV',
      medicalQuestion: 'O que é a hipertensão?',
      answer: ['Pressão arterial elevada', 'Falta de sintomas perceptíveis', 'Aumento do risco de doenças cardiovasculares'],
      table: 'Vietnam',
      hints: ['A hipertensão pode ser controlada com mudanças no estilo de vida e medicação.', 'É importante monitorar a pressão arterial regularmente.', 'Se não tratada, pode levar a complicações graves, como AVC ou insuficiência renal.']
    },
    luiscampos: {
      fullName: 'Luis Campos',
      medicalQuestion: 'O que é diabetes tipo 2?',
      answer: ['Resistência à insulina', 'Níveis elevados de glicose no sangue', 'Falta de sintomas nos estágios iniciais'],
      table: 'Vietnam',
      hints: ['O diabetes tipo 2 é geralmente controlado com dieta, exercício e medicação.', 'A prevenção envolve manter um peso saudável e uma alimentação equilibrada.', 'O diagnóstico é feito com exames de sangue para medir os níveis de glicose.']
    },
    mulherLuisCampos: {
      fullName: 'Mulher Luis Campos',
      medicalQuestion: 'O que é o câncer de pulmão?',
      answer: ['Tumor maligno nos pulmões', 'Tosse persistente', 'Dificuldade para respirar'],
      table: 'Vietnam',
      hints: ['O tabagismo é a principal causa do câncer de pulmão.', 'Os sintomas incluem tosse crônica, falta de ar e dor no peito.', 'O tratamento pode incluir cirurgia, quimioterapia e radioterapia.']
    },
    jorgecampos: {
      fullName: 'Jorge Campos',
      medicalQuestion: 'O que é a insuficiência cardíaca?',
      answer: ['Incapacidade do coração de bombear sangue suficiente', 'Falta de ar', 'Edema nas pernas'],
      table: 'Vietnam',
      hints: ['Pode ser causada por doenças cardíacas, como infarto ou hipertensão.', 'O tratamento envolve medicamentos e, em alguns casos, dispositivos como marcapasso.', 'Mudanças no estilo de vida, como dieta e exercício, são importantes no controle.']
    },
    joaomendes: {
      fullName: 'João Mendes',
      medicalQuestion: 'O que é a doença celíaca?',
      answer: ['Doença autoimune desencadeada pelo glúten', 'Danos ao intestino delgado', 'Diarreia crônica'],
      table: 'Vietnam',
      hints: ['A única forma de tratamento é uma dieta rigorosa sem glúten.', 'Pode causar sintomas como dor abdominal e cansaço.', 'O diagnóstico é feito por exames de sangue e biópsia intestinal.']
    },
    ugoanasobi: {
      fullName: 'Ugo Anasobi',
      medicalQuestion: 'O que é a trombose?',
      answer: ['Formação de coágulos sanguíneos', 'Dor e inchaço na perna', 'Risco de embolia pulmonar'],
      table: 'Vietnam',
      hints: ['A trombose pode ser causada por imobilização prolongada, como em viagens longas.', 'O tratamento envolve anticoagulantes para prevenir complicações.', 'Manter-se ativo e hidratado pode ajudar na prevenção.']
    },
    filhacarlos: {
      fullName: 'Filha Carlos',
      medicalQuestion: 'O que é a meningite?',
      answer: ['Inflamação das membranas que cobrem o cérebro e a medula espinhal', 'Febre alta', 'Rigidez no pescoço'],
      table: 'Vietnam',
      hints: ['A meningite pode ser causada por infecções virais ou bacterianas.', 'O tratamento depende do tipo de meningite e pode envolver antibióticos ou antivirais.', 'A vacinação pode prevenir alguns tipos de meningite.']
    },
    carlosbv: {
      fullName: 'Carlos BV',
      medicalQuestion: 'O que é a apneia do sono?',
      answer: ['Interrupção temporária da respiração durante o sono', 'Ronco alto', 'Cansaço excessivo durante o dia'],
      table: 'Vietnam',
      hints: ['A apneia do sono pode ser tratada com CPAP ou outros dispositivos para manter as vias respiratórias abertas.', 'A obesidade é um fator de risco significativo para a apneia do sono.', 'O diagnóstico é feito por meio de um estudo do sono.']
    },
    namJoaoMendes: {
      fullName: 'Nam. João Mendes',
      medicalQuestion: 'O que é a osteoporose?',
      answer: ['Perda de massa óssea', 'Aumento do risco de fraturas', 'Dores nas costas'],
      table: 'Vietnam',
      hints: ['A osteoporose é comum em pessoas mais velhas, especialmente mulheres pós-menopausa.', 'O tratamento envolve medicamentos, exercícios e aumento da ingestão de cálcio e vitamina D.', 'Exames de densidade óssea podem diagnosticar a condição.']
    },
    duartalemao: {
      fullName: 'Duarte Alemão',
      medicalQuestion: 'O que é a doença de Parkinson?',
      answer: ['Doença neurodegenerativa que afeta o movimento', 'Tremores nas mãos', 'Rigidez muscular'],
      table: 'Vietnam',
      hints: ['A doença de Parkinson pode ser tratada com medicamentos que aumentam os níveis de dopamina no cérebro.', 'Os sintomas incluem tremores, rigidez muscular e dificuldade de equilíbrio.', 'A fisioterapia pode ajudar a melhorar a qualidade de vida.']
    },
    amanda: {
      fullName: 'Amanda',
      medicalQuestion: 'O que é a hipertensão?',
      answer: ['Pressão arterial elevada', 'Falta de sintomas perceptíveis', 'Aumento do risco de doenças cardiovasculares'],
      table: 'Brasil',
      hints: ['A hipertensão pode ser controlada com mudanças no estilo de vida e medicação.', 'É importante monitorar a pressão arterial regularmente.', 'Se não tratada, pode levar a complicações graves, como AVC ou insuficiência renal.']
    },
    marcio: {
      fullName: 'Marcio',
      medicalQuestion: 'O que é diabetes tipo 2?',
      answer: ['Resistência à insulina', 'Níveis elevados de glicose no sangue', 'Falta de sintomas nos estágios iniciais'],
      table: 'Brasil',
      hints: ['O diabetes tipo 2 é geralmente controlado com dieta, exercício e medicação.', 'A prevenção envolve manter um peso saudável e uma alimentação equilibrada.', 'O diagnóstico é feito com exames de sangue para medir os níveis de glicose.']
    },
    luana: {
      fullName: 'Luana',
      medicalQuestion: 'O que é o câncer de pulmão?',
      answer: ['Tumor maligno nos pulmões', 'Tosse persistente', 'Dificuldade para respirar'],
      table: 'Brasil',
      hints: ['O tabagismo é a principal causa do câncer de pulmão.', 'Os sintomas incluem tosse crônica, falta de ar e dor no peito.', 'O tratamento pode incluir cirurgia, quimioterapia e radioterapia.']
    },
    avomarilda: {
      fullName: 'Avó Marilda',
      medicalQuestion: 'O que é a insuficiência cardíaca?',
      answer: ['Incapacidade do coração de bombear sangue suficiente', 'Falta de ar', 'Edema nas pernas'],
      table: 'Brasil',
      hints: ['Pode ser causada por doenças cardíacas, como infarto ou hipertensão.', 'O tratamento envolve medicamentos e, em alguns casos, dispositivos como marcapasso.', 'Mudanças no estilo de vida, como dieta e exercício, são importantes no controle.']
    },
    mirela: {
      fullName: 'Mirela',
      medicalQuestion: 'O que é a doença celíaca?',
      answer: ['Doença autoimune desencadeada pelo glúten', 'Danos ao intestino delgado', 'Diarreia crônica'],
      table: 'Brasil',
      hints: ['A única forma de tratamento é uma dieta rigorosa sem glúten.', 'Pode causar sintomas como dor abdominal e cansaço.', 'O diagnóstico é feito por exames de sangue e biópsia intestinal.']
    },
    dilson: {
      fullName: 'Dilson',
      medicalQuestion: 'O que é a trombose?',
      answer: ['Formação de coágulos sanguíneos', 'Dor e inchaço na perna', 'Risco de embolia pulmonar'],
      table: 'Brasil',
      hints: ['A trombose pode ser causada por imobilização prolongada, como em viagens longas.', 'O tratamento envolve anticoagulantes para prevenir complicações.', 'Manter-se ativo e hidratado pode ajudar na prevenção.']
    },
    davidson: {
      fullName: 'Davidson',
      medicalQuestion: 'O que é a meningite?',
      answer: ['Inflamação das membranas que cobrem o cérebro e a medula espinhal', 'Febre alta', 'Rigidez no pescoço'],
      table: 'Brasil',
      hints: ['A meningite pode ser causada por infecções virais ou bacterianas.', 'O tratamento depende do tipo de meningite e pode envolver antibióticos ou antivirais.', 'A vacinação pode prevenir alguns tipos de meningite.']
    },
    tiadora: {
      fullName: 'Tia Dora',
      medicalQuestion: 'O que é a apneia do sono?',
      answer: ['Interrupção temporária da respiração durante o sono', 'Ronco alto', 'Cansaço excessivo durante o dia'],
      table: 'Brasil',
      hints: ['A apneia do sono pode ser tratada com CPAP ou outros dispositivos para manter as vias respiratórias abertas.', 'A obesidade é um fator de risco significativo para a apneia do sono.', 'O diagnóstico é feito por meio de um estudo do sono.']
    },
    irmasara: {
      fullName: 'Irmã Sara',
      medicalQuestion: 'O que é a osteoporose?',
      answer: ['Perda de massa óssea', 'Aumento do risco de fraturas', 'Dores nas costas'],
      table: 'Brasil',
      hints: ['A osteoporose é comum em pessoas mais velhas, especialmente mulheres pós-menopausa.', 'O tratamento envolve medicamentos, exercícios e aumento da ingestão de cálcio e vitamina D.', 'Exames de densidade óssea podem diagnosticar a condição.']
    },
    anasonetti: {
      fullName: 'Ana Sonetti',
      medicalQuestion: 'O que é a doença de Parkinson?',
      answer: ['Doença neurodegenerativa que afeta o movimento', 'Tremores nas mãos', 'Rigidez muscular'],
      table: 'Brasil',
      hints: ['A doença de Parkinson pode ser tratada com medicamentos que aumentam os níveis de dopamina no cérebro.', 'Os sintomas incluem tremores, rigidez muscular e dificuldade de equilíbrio.', 'A fisioterapia pode ajudar a melhorar a qualidade de vida.']
    },
    julia: {
      fullName: 'Julia',
      medicalQuestion: 'O que é a leucemia?',
      answer: ['Câncer das células sanguíneas', 'Fadiga extrema', 'Pele pálida'],
      table: 'Brasil',
      hints: ['A leucemia pode ser tratada com quimioterapia, radioterapia e transplante de medula óssea.', 'Sintomas incluem febre, dor óssea e perda de peso.', 'O diagnóstico é feito através de exames de sangue e biópsia de medula óssea.']
    },
    luisotavio: {
      fullName: 'Luis Otavio',
      medicalQuestion: 'O que é a tuberculose?',
      answer: ['Infecção bacteriana nos pulmões', 'Tosse com sangue', 'Febre e suores noturnos'],
      table: 'Brasil',
      hints: ['A tuberculose é tratada com antibióticos por um período prolongado.', 'Pode ser fatal se não tratada adequadamente.', 'O diagnóstico é feito por radiografia de tórax e exames de escarro.']
    },
    ruiBarquina: {
      fullName: 'Rui Barquina',
      medicalQuestion: 'O que é a apneia do sono?',
      answer: ['Interrupção temporária da respiração durante o sono', 'Ronco alto', 'Cansaço excessivo durante o dia'],
      table: 'Portugal',
      hints: ['A apneia do sono pode ser tratada com CPAP ou outros dispositivos para manter as vias respiratórias abertas.', 'A obesidade é um fator de risco significativo para a apneia do sono.', 'O diagnóstico é feito por meio de um estudo do sono.']
    }
  };
  